import React from 'react';
import CategoryNavigation from '../ProductListing/CategoryNavigation';

const CategoriesMenu = () => {
  return (
    <div className="px-4 pb-2 pt-3 [&>div]:text-lg [&_div]:flex [&_ul]:gap-4 [&_ul]:border-b-0">
      <CategoryNavigation />
    </div>
  );
};

export default CategoriesMenu;
